import { render, staticRenderFns } from "./SectionResultat.vue?vue&type=template&id=486f3e78&scoped=true"
import script from "./SectionResultat.vue?vue&type=script&lang=js"
export * from "./SectionResultat.vue?vue&type=script&lang=js"
import style0 from "./SectionResultat.vue?vue&type=style&index=0&id=486f3e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f3e78",
  null
  
)

export default component.exports